<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset>
    <v-progress-linear :active="loading" indeterminate></v-progress-linear>
    <div style="position:relative!important;">
      <v-sheet>
        <v-btn
          style="z-index:20; position:absolute; top:0; right:0;"
          class="mt-1 mr-1"
          @click="
            () => {
              this['ProductType/fetchProductTypes']({ page: this.page });
              $router.push('/producttype');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card class="elevation-0">
          <v-list>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>Product Type</v-list-item-title>
                <v-list-item-subtitle>{{ productType.name }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="deleteProductType" outlined color="red">
              Delete
            </v-btn>
            <v-btn @click="goToEdit" color="indigo" outlined>
              Edit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </div>
    <confirm ref="confirm"></confirm>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import confirm from '../../components/Confirm.vue';

export default {
  props: {
    show: false,
    page: 0
  },
  components: {
    confirm
  },
  beforeMount() {
    if (this.show) {
      this['ProductType/getProductType']({ id: this.$route.params.id }).finally(() => {
        if (this.productType.name == '') {
          this.$router.push('/producttype');
        }
      });
    }
  },
  mounted() {
    if (this.show) {
      this['ProductType/getProductType']({ id: this.$route.params.id });
    }
  },
  computed: {
    ...mapState({
      loading: state => state.ProductType.getProductTypeLoading,
      productType(state) {
        if (typeof state.ProductType.productType.data == 'undefined') {
          return {
            name: ''
          };
        }
        return state.ProductType.productType.data;
      }
    })
  },
  methods: {
    ...mapActions(['ProductType/fetchProductTypes', 'ProductType/getProductType']),
    deleteProductType() {
      this.$refs.confirm
        .open(
          'Delete Product Type',
          'Are you sure you want to delete product type ' + this.productType.name + '?',
          { color: '#f44336' }
        )
        .then(confirm => {
          axios
            .delete(`api/v1/type/${this.$route.params.id}`)
            .then(response => {
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Product Type deleted...',
                color: 'success'
              });
              this['ProductType/fetchProductTypes']({ page: this.page });
              this.$router.push('/producttype');
            })
            .catch(error => {
              if (error.response.status == 403) {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              } else {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data.errors['id'][0],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {});
        });
    },
    goToEdit() {
      this.$router.push(`/producttype/${this.$route.params.id}/edit`);
    }
  }
};
</script>
